import styled from '@emotion/styled/macro'
import Form from '../../../components/Form.ui'

const AuthForm = styled(Form)`
    overflow: auto;
    margin: 0 auto;
    > button {
        margin-top: 2rem;
        width: 100%;
    }
`
export default AuthForm
